module.exports = __webpack_public_path__ + "static/albion-decorators-logo-42808213c796dae10921fedb38ea9921.svg";